export default __webpack_public_path__ + "static/media/registration_page_cp.16c6f7cb.jpg";